import {
  Block,
  BlockTitle,
  Link,
  PageContent,
  Sheet,
  Toolbar,
} from "framework7-react";
import { useBackClose } from "../../hooks/use-back-close";
import TransferCode from "./transfer-code";

const TransferSheet = ({ opened, onClose }) => {
  const releaseBack = useBackClose(opened, onClose);

  return (
    <Sheet
      className="transfer-sheet"
      style={{ height: "auto" }}
      opened={opened}
      onSheetClose={releaseBack}
      onSheetClosed={onClose}
      swipeToClose
      backdrop
    >
      <Toolbar>
        <div className="left"></div>
        <div className="right">
          <Link sheetClose iconOnly aria-label="Schließen">
            <i className="icon icon-close" />
          </Link>
        </div>
      </Toolbar>
      <PageContent>
        <BlockTitle large>Auf anderem Gerät öffnen</BlockTitle>
        <Block>
          Öffne Split It auf dem anderen Gerät und tippe auf dem
          Startbildschirm auf „Code eingeben“. Danach sind dort alle deine
          Gruppen.
        </Block>
        <TransferCode active={opened} />
        <Block className="install-note">
          Der Code gilt 10 Minuten und nur einmal. Wer ihn eingibt, sieht alle
          deine Gruppen – gib ihn nicht an andere weiter.
        </Block>
      </PageContent>
    </Sheet>
  );
};

export default TransferSheet;
